import { useTranslation } from "react-i18next";
import styles from "./Workflow.module.scss";
import { useLocation } from "react-router";
import { useState } from "react";

const WorkflowTitle: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const getTitle = (pathname: string) => {
    if (pathname.indexOf("delete-publication") > -1) {
      return t("deletePublication").toString();
    } else if (pathname.indexOf("modify-publication") > -1) {
      return t("modifyPublication").toString();
    } else {
      return t("newPublication").toString();
    }
  };

  return (
    <div className={styles.workflowTitle}>
      <h2>{t("publication")} <strong>{t("publicationHUB")}</strong></h2>
      <h3>{getTitle(location.pathname)}</h3>
    </div>
  );
};

export default WorkflowTitle;
